<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'

// import axios from 'axios'

export default {
	page: {
		title: '360MDR Reports',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout,
		Widget
	},
	props: {
		name: {
			type: String,
			default: 'main.json'
		}
	},
	data() {
		return {
			finishedWidgetsCount: 0,
			widgetsStatus: [],
			showDownloadButton: false,
			showGenerating: true,
			startDateTime: null,
			endDateTime: null,
			startDateTimeShow: null,
			endDateTimeShow: null,
			error: null,
			title: 'Monitoreo General - Fundación Cardio Infantil',
			spacer: '',
			startEpoch: 0,
			endEpoch: 0,
			date: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
			dashboard: {
				"widgets": [
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"id": "widget2",
						"name": "ACCIONES CONTRA AMENAZAS",
						"cols": "col-md-4",
						"height_class": "tall_widget",
						"component": "dpie",
						"type": "radialBar",
						"colors": ['#1ab7ea', '#0084ff', '#39539E', '#0077B5', '#0077B5'],
						"range": true,
						"refresh": 60000,
						"colorsByLabel": {
							"reset-both": "#DC001E",
							"block-url": "#DC001E",
							"drop": "#DC001E",
							"reset-server": "#DC001E",
							"sinkhole": "#DC001E",
							"deny": "#DC001E",
							"block": "#DC001E",
							"alert": "#01AD00",
							"allow": "#01AD00"
						},
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'THREAT' \n| group action = count() by unmapped.action_value \n| sort -action\n| limit 10",
							"rekey": { 
								"reference": "label"
							},
						},
					},
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"name": "TOP DE AMENAZAS",
						"cols": "col-md-8",
						"height_class": "short_widget",
						"component": "multicolumn",
						"refresh": 60000,
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'THREAT' \n| group threat_id = count() by unmapped.threat_id \n| sort -threat_id\n| limit 10",
							"columns": [
								{
									"name": "Amenaza",
									"type": "text",
									"reference": "reference",
									"class": "tleft reference",
									"maxlength": 60,
									"width": "50%"
								},
								{
									"name": "Cantidad",
									"type": "number",
									"reference": "count",
									"class": "tcenter",
									"width": "10%"
								},
								{
									"name": "",
									"type": "bar",
									"reference": "count",
									"class": "tleft value",
									"width": "20%"
								}
							]
						},
					},
					// {
					// 	"id": "widget1",
					// 	"name": "TOP DE PAISES DESDE DONDE MÁS SE GENERAN AMENAZAS",
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&field=source.geo.country_iso_code&cols_titles=reference:Amenaza,count:Cuenta",
					// 	"cols": "col-md-6",
					// 	"height_class": "tall_widget",
					// 	"component": "worldmap",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "country_code",
					// 			"doc_count": "count"
					// 		},
					// 	},
					// },
					// {
					// 	"id": "widget2",
					// 	"name": "TOP DE PAISES HACIA DONDE MÁS SE DIRIGEN AMENAZAS",
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&field=destination.geo.country_iso_code&cols_titles=reference:Amenaza,count:Cuenta",
					// 	"cols": "col-md-6",
					// 	"height_class": "tall_widget",
					// 	"component": "worldmap",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "country_code",
					// 			"doc_count": "count"
					// 		},
					// 	},
					// },
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"name": "TOP DE TRAFICO POR APLICACION",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"refresh": 60000,
						"range": true,
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'TRAFFIC' \n| group TotalBytes = sum(traffic.bytes) by app_name \n| sort -TotalBytes\n| limit 10",
							"columns": [
								{
									"name": "Aplicación",
									"type": "text",
									"reference": "reference",
									"class": "tleft reference",
									"maxlength": 60,
									"width": "10%"
								},
								{
									"name": "Bytes",
									"type": "number",
									"reference": "count",
									"class": "tcenter",
									"width": "10%"
								},
								{
									"name": "",
									"type": "bar",
									"reference": "count",
									"class": "tleft value",
									"width": "20%"
								}
							]
						},
					},
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"name": "TOP DE SESIONES DE RED POR APLICACION",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"refresh": 60000,
						"range": true,
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'TRAFFIC' \n| group TotalSession = count() by app_name | sort - TotalSession | limit 10",
							"columns": [
								{
									"name": "Aplicación",
									"type": "text",
									"reference": "reference",
									"class": "tleft reference",
									"maxlength": 60,
									"width": "10%"
								},
								{
									"name": "Sesiones",
									"type": "number",
									"reference": "count",
									"class": "tcenter",
									"width": "10%"
								},
								{
									"name": "",
									"type": "bar",
									"reference": "count",
									"class": "tleft value",
									"width": "20%"
								}
							]
						},
					},
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"name": "TOP DE ACTORES QUE GENERAN AMENAZAS (actor.user.name)",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"refresh": 60000,
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'THREAT' \n| group username = count() by actor.user.name \n| sort -username\n| limit 10",
							"columns": [
								{
									"name": "Usuario",
									"type": "text",
									"reference": "reference",
									"class": "tleft reference",
									"maxlength": 60,
									"width": "10%"
								},
								{
									"name": "Amenazas",
									"type": "number",
									"reference": "count",
									"class": "tcenter",
									"width": "10%"
								},
								{
									"name": "",
									"type": "bar",
									"reference": "count",
									"class": "tleft value",
									"width": "20%"
								}
							]
						},
					},
					{
						"source": "/sentinelone/singularity/powerquery?more=no",
						"name": "TOP DE ACTORES QUE GENERAN AMENAZAS (unmapped.dst_user)",
						"cols": "col-md-6",
						"height_class": "short_widget",
						"component": "multicolumn",
						"refresh": 60000,
						"params": {
							"query": "dataSource.name = 'Palo Alto Networks Firewall' dataSource.category = 'security' \n| filter metadata.log_name = 'THREAT' \n| group username = count() by unmapped.dst_user \n| sort -username\n| limit 10",
							"columns": [
								{
									"name": "Usuario",
									"type": "text",
									"reference": "reference",
									"class": "tleft reference",
									"maxlength": 60,
									"width": "10%"
								},
								{
									"name": "Amenazas",
									"type": "number",
									"reference": "count",
									"class": "tcenter",
									"width": "10%"
								},
								{
									"name": "",
									"type": "bar",
									"reference": "count",
									"class": "tleft value",
									"width": "20%"
								}
							]
						},
					},
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=destination.user.name&cols_titles=reference:Usuario Destino,count:Cuenta",
					// 	"name": "TOP DE USUARIOS DESTINO EN AMENAZAS",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Usuarios",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=source.ip&cols_titles=reference:IP Fuente,count:Cuenta",
					// 	"name": "TOP DE DIRECCIONES FUENTE EN AMENAZAS",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Hosts Fuente",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=destination.ip&cols_titles=reference:IP Destino,count:Cuenta",
					// 	"name": "TOP DE DIRECCIONES DESTINO EN AMENAZAS",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Hosts Destino",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=url.original&cols_titles=reference:URL,count:Cuenta",
					// 	"name": "TOP DE URL QUE PASARON POR FILTRADO",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "URL",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=panw.panos.url.category&cols_titles=reference:Categoría,count:Cuenta",
					// 	"name": "TOP DE CATEGORIAS DE URL QUE PASARON POR FILTRADO",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Categoría",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=panw.panos.ruleset&cols_titles=reference:Regla,count:Cuenta",
					// 	"name": "TOP DE REGLAS RELACIONADAS CON AMENAZAS",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Regla",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-panw.panos-default-*&auto_column=yes&field=network.application&cols_titles=reference:Aplicación,count:Cuenta",
					// 	"name": "TOP DE APLICACIONES RELACIONADAS CON AMENAZAS",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Aplicación",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// },
					// {
					// 	"source": "/sentinelone/generic/top?collection=sentinelone_threats&variables=agentRealtimeInfo.agentComputerName,threatInfo.processUser,threatInfo.classification,agentRealtimeInfo.agentOsName,threatInfo.threatName&outvars=name,user,classification,os,threat&tvariable=threatInfo.updatedAt&minutes=1440&last=yes&altorder=count&maxlength=100",
					// 	"name": "TOP DE AGENTES CON MÁS AMENAZAS EN EL MDR",
					// 	"id": "widget2222",
					// 	"cols": "col-md-12",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"params": {
					// 		"columns": [
					// 			{
					// 				"name": "Dispositivo",
					// 				"type": "text",
					// 				"reference": "name",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Usuario del Proceso",
					// 				"type": "text",
					// 				"reference": "user",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "20%"
					// 			},
					// 			{
					// 				"name": "Tipo de Amenaza",
					// 				"type": "text",
					// 				"reference": "classification",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Nombre de la Amenaza",
					// 				"type": "text",
					// 				"reference": "threat",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "25%"
					// 			},
					// 			{
					// 				"name": "Sistema Operativo",
					// 				"type": "text",
					// 				"reference": "os",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "20%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	},
					// 	"range": true,
					// 	"refresh": 60000
					// },
					// {
					// 	"source": "/sentinelone/generic/top?collection=sentinelone_threats&variables=threatInfo.classification&outvars=classification&tvariable=threatInfo.updatedAt&minutes=1440&last=yes&altorder=count&maxlength=100",
					// 	"name": "TOP DE AMENAZAS POR TIPO EN EL MDR",
					// 	"id": "widget2222",
					// 	"cols": "col-md-4",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"params": {
					// 		"columns": [
					// 			{
					// 				"name": "Tipo de la Amenaza",
					// 				"type": "text",
					// 				"reference": "classification",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "20%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "10%"
					// 			}
					// 		]
					// 	},
					// 	"range": true,
					// 	"refresh": 60000
					// }, 
					// {
					// 	"source": "/sentinelone/generic/top?collection=sentinelone_threats&variables=threatInfo.threatName&outvars=threat&tvariable=threatInfo.updatedAt&minutes=1440&last=yes&altorder=count&maxlength=100",
					// 	"name": "TOP DE AMENAZAS POR NOMBRE EN EL MDR",
					// 	"id": "widget2222",
					// 	"cols": "col-md-8",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"params": {
					// 		"columns": [
					// 			{
					// 				"name": "Nombre de la Amenaza",
					// 				"type": "text",
					// 				"reference": "threat",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "20%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "10%"
					// 			}
					// 		]
					// 	},
					// 	"range": true,
					// 	"refresh": 60000
					// }, 
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-http_endpoint.bitdefender*&auto_column=yes&field=json.params.events.module&cols_titles=reference:Tipo%20de%20Evento,count:Cuenta",
					// 	"name": "DISTRIBUCIÓN DE TIPOS DE EVENTOS DE BITDEFENDER",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Tipo de Evento",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		],
					// 		"reval": {
					// 			"field": "reference",
					// 			"data": {
					// 				"adcloud": "Cloud AD Integration",
					// 				"aph": "Antiphishing",
					// 				"av": "Antimalware",
					// 				"avc": "Advanced Threat Control (ATC)",
					// 				"dp": "Data Protection",
					// 				"exchange-malware": "Exchange Malware Detection",
					// 				"exchange-organization-info": "Exchange License Usage Limit Has Been Reached",
					// 				"exchange-user-credentials": "Exchange User Credentials",
					// 				"fw": "Firewall",
					// 				"hd": "Hyper Detect event",
					// 				"modules": "Product Modules Status",
					// 				"network-sandboxing": "Sandbox Analyzer Detection",
					// 				"registration": "Product Registration",
					// 				"supa-update-status": "Outdated Update Server",
					// 				"sva-load": "Overloaded Security Server",
					// 				"sva": "Security Server Status",
					// 				"antiexploit": "Antiexploit Event",
					// 				"network-monitor": "Network Attack Defense Event",
					// 				"task-status": "Task Status",
					// 				"uc": "User Control/Content Control",
					// 				"storage-antimalware": "Storage Antimalware Event",
					// 				"install": "Install Agent",
					// 				"uninstall": "Uninstall Agent",
					// 				"hwid-change": "Hardware ID Change",
					// 				"endpoint-moved-in": "Endpoint moved in",
					// 				"endpoint-moved-out": "Endpoint moved out",
					// 				"troubleshooting-activity": "Troubleshooting activity",
					// 				"device-control": "Device Control",
					// 				"ransomware-mitigation": "Ransomware activity detection",
					// 				"new-incident": "New Incident"
					// 			}
					// 		}
					// 	},
					// },
					// {
					// 	"source": "/es/agg/single_term?index_base=.ds-logs-http_endpoint.bitdefender*&auto_column=yes&field=json.params.events.malware_name&cols_titles=reference:Nombre%20del%20Malware,count:Cuenta",
					// 	"name": "DISTRIBUCIÓN DE MALWARE IDENTIFICADO POR BITDEFENDER",
					// 	"cols": "col-md-6",
					// 	"height_class": "short_widget",
					// 	"component": "multicolumn",
					// 	"refresh": 60000,
					// 	"params": {
					// 		"rekey": { 
					// 			"key": "reference",
					// 			"doc_count": "count"
					// 		},
					// 		"columns": [
					// 			{
					// 				"name": "Nombre del Malware",
					// 				"type": "text",
					// 				"reference": "reference",
					// 				"class": "tleft reference",
					// 				"maxlength": 60,
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "Cantidad",
					// 				"type": "number",
					// 				"reference": "count",
					// 				"class": "tcenter",
					// 				"width": "10%"
					// 			},
					// 			{
					// 				"name": "",
					// 				"type": "bar",
					// 				"reference": "count",
					// 				"class": "tleft value",
					// 				"width": "20%"
					// 			}
					// 		]
					// 	}
					// }
				]
			},
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			base: 0,
			pdfConfig: {
				margin: 0.2,
				filename: 'report.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
				pagebreak: { mode: 'css', before: '#page2el' },
				_pageBreak: { mode: 'avoid-all', before: '.break-page', after:'.break-page'}
			},
		}
	},
	computed: {
		dateTimeFormatedRange: function () {
			let res = ''
			if (this.startDateTimeShow !== null) res += this.startDateTimeShow + ' - '
			if (this.endDateTimeShow !== null) res += this.endDateTimeShow 		
			return res
		}
	},
	mounted () {
		// this.showModal()
      	setTimeout(() => {
				this.showDownloadButton = true
				this.showGenerating = false
			}, 15000)
	},
	methods: {
		showModal() {
			this.$refs['modal-datetime'].show()
		},
		handleOk (evt) {
			let that = this
			if (that.startDateTime === null) {
				that.error = "Please select a start date and time"
				evt.preventDefault()
			} else if (that.endDateTime === null) {
				that.error = "Please select an end date and time"
				evt.preventDefault()
			} else {
				that.startEpoch = parseInt(new Date(that.startDateTime).getTime()/1000)
				that.endEpoch = parseInt(new Date(that.endDateTime).getTime()/1000)
				console.log(that.startEpoch, that.endEpoch, that.endEpoch - that.startEpoch)
				that.base += 100
				that.spacer = ' -  '
				that.error = null
				that.startDateTimeShow = that.startDateTime
				that.endDateTimeShow = that.endDateTime
				that.showDownloadButton = false
				that.showGenerating = true
				that.finishedWidgetsCount = 0
				that.widgetsStatus = []
				const waitTime = parseInt((that.endEpoch-that.startEpoch)/10)
				setTimeout(() => {
					that.showDownloadButton = true
					that.showGenerating = false
				}, waitTime)
			}
		},
		widgetFinished(id, ok, aux) {
			this.finishedWidgetsCount += 1
			this.widgetsStatus.push({id: id, ok: ok, aux: aux})
		},
		downloadPdf() {
			const element = document.getElementById('pdfcontent')
			html2pdf(element, this.pdfConfig)
    	},
	},
}
</script>

<template>
	<Layout>
		<div class="container" style="max-width: 1420px !important;">
			<br></br>
			<div class="row">
				<div class="col-md-12" style="text-align:center;">
					<template v-if="finishedWidgetsCount === dashboard.widgets.length">
						<b-button class="btn btn-primary btn-sm mr-1" variant="light" @click="downloadPdf()">
							Download PDF
						</b-button>
					</template>
					<template v-else>
						<span>
							Generating...
						</span>
					</template>
				</div>
			</div>
			<div id="pdfcontent" style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;">
				<section slot="pdf-content">
					<br><br><br>
					<div class="row">
						<div class="col-md-12 align-items-center" style="text-align:center">
							<h2 style="align:center;cursor:pointer;">
								{{ title }}
							</h2>
							<h4 style="align:center;cursor:pointer;" v-on:click="showModal">
								{{ dateTimeFormatedRange || 'últimas 24 horas'}}
							</h4>
						</div>
					</div>
					<br>
					<div class="row">
						<template v-for="(widget, index) in dashboard.widgets">
							<Widget v-bind:key="index + base"
								:id="widget.id"
								:title="widget.name"
								:component="widget.component"
								:source="widget.source"
								:cols="widget.cols"
								:trend="widget.trend"
								:wclass="widget.class"
								:type="widget.type"
								:colors="widget.colors"
								:colorsByLabel="widget.colorsByLabel"
								:range="widget.range"
								:cardStyle="widget.cardStyle"
								:start="startEpoch"
								:end="endEpoch"
								:error="widget.error"
								:limit="top"
								:params="widget.params"
								:auxBool="widget.auxBool"
								@finished="widgetFinished"
							/>
						</template>
						<span class="break-page" />

					</div>
				</section>
			</div>
		</div>
		<b-modal
			ref="modal-datetime"
			id="incident.incident_id"
			size="xs"
			title="Select Time Range"
			:ok-only=true
			:centered=true
			:no-fade=true
			@ok="handleOk">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>Start</label>
					<flat-pickr
						v-model="startDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>End</label>
					<flat-pickr
						v-model="endDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
			</div>
			<div v-if="error !== null" class="row">
				<div class="col-md-12 severity_high" style="text-align:center">
					{{ error }}
				</div>
			</div>

		</b-modal>
	</Layout>
</template>


